import database from "../../../services/database";
import IconButton from "../../../components/icon-button";
import React from "react";
import SEO from "../../../components/SEO";

function Home() {
    return (
        <>
            <SEO 
                title="Órteses"
                description="Órteses personalizadas para ombro, quadril, pés, membros superiores e inferiores, tronco e produtos para diabéticos. Confecção sob medida."
                keywords="órteses, órtese sob medida, órtese ombro, órtese quadril, órtese pé diabético, órtese tronco, órtese joelho"
                canonicalUrl="https://www.saojoseortopedicos.com.br/produtos/orteses"
            />
            <h2>{database.orteses.title}</h2>
            <p>
                {database.orteses.description}
            </p>
            {
                <ul className="icones">
                    {
                        database.orteses.items.map(y => {
                            return (
                                <li>
                                    <IconButton
                                        title={y.title}
                                        icon={y.icon}
                                        path={y.path}
                                        iconLegend={y.iconLegend}
                                    />
                                </li>
                            );
                        })
                    }
                </ul>
            }
        </>
    );
}

export default Home;